define(function(require, exports, module) {
    'use strict';

    const _ = require('underscore');
    const RegistrationStepModel = require('portlets/registration/registration.step.model');

    module.exports = RegistrationStepModel.extend({

        getData: function(data) {
            data = RegistrationStepModel.prototype.getData.call(this, data);
            data = this._parsePersonalId(data);

            return data;
        },

        /**
         * Get proper personalId field
         * @param  {Object} data
         * @return {Object}
         */
        _parsePersonalId: function(data) {
            const result = _.omit(data, 'personalId');

            if (data.personalId) {
                result.personalId = data.personalId.replace(/(\.)|(-)/g, '');
            }

            return result;
        }
    });
});
